import React, { useEffect, useState } from "react";
import Commongrid from "../../common/Commongrid";
import formatDateAndTime from "../../common/formatDateAndTime";
import { getCityName } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

function createData(
  id,
  source,
  bookingCode,
  bookingstatus,
  startdate,
  enddate,
  city,
  amount,
  customerName,
  customerId,
  customerEmail,
  customerMobile,
  lineItems,
  tagging,
) {
  return {
    id,
    source,
    bookingCode,
    bookingstatus,
    startdate,
    enddate,
    city,
    amount,
    customerName,
    customerId,
    customerEmail,
    customerMobile,
    lineItems,
    tagging,
  };
}

const Tagbookings = ({
  workOrderDetail,
  getTaggedBookings,
  setTaggedBookings,
  taggedBookings,
  handleImageOpen,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  const bookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  delete bookingStatus?.inverted;
  let bookingCharges = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingCharges;
  delete bookingCharges?.inverted;
  const fleetChargeValues = bookingCharges;
  const fleetBookingvalue = bookingStatus;
  let token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [flippedCard, setFlippedCard] = useState(null);
  const [chargesData, setChargesData] = useState([]);
  const [searchvalues, setSearchValues] = useState("");
  const [filteredBookings, setFilteredBookings] = useState([]);
  let damageChargeInvertedId = JSON.parse(localStorage.getItem("catalogValues"))
    ?.bookingCharges?.inverted?.damage;
  let downTimeChargeInvertedId = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingCharges?.inverted?.downtimeCharges;
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    row: null,
  });

  const filteredKeys = Object.keys(fleetBookingvalue).filter(
    (key) =>
      !fleetBookingvalue[key].includes("Inquiry") &&
      !fleetBookingvalue[key].includes("Payment Pending") &&
      !fleetBookingvalue[key].includes("Document Pending") &&
      !fleetBookingvalue[key].includes("Verification Pending") &&
      !fleetBookingvalue[key].includes("Booking Confirmed") &&
      !fleetBookingvalue[key].includes("Cancelled") &&
      !fleetBookingvalue[key].includes("Booking Closed"),
  );
  const filteredChargesDataKeys = Object.keys(fleetChargeValues).filter(
    (key) =>
      fleetChargeValues[key].includes("Damage") ||
      fleetChargeValues[key].includes("Downtime Charges"),
  );
  const [totalCount, setTotalCount] = useState(0);
  const [bookingdetails, setBookingDetails] = useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [vehicleId, setVehicleId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState({});

  const getCityNameAPI = async (id) => {
    const apiDetails = await getCityName(id);
    const response = await commonapihandler(
      apiDetails?.apiUrl,
      apiDetails?.method,
    );
    if (response) {
      setCities(response);
    }
  };

  const handleViewCharges = async (bookingid, lineItems) => {
    setFlippedCard(bookingid);
    setChargesData(lineItems || []);
  };

  const dataToUse =
    filteredBookings.length > 0 ? filteredBookings : bookingdetails;

  const rows =
    (dataToUse &&
      dataToUse?.map((item) =>
        createData(
          item?.id,
          item?.source,
          item?.bookingCode,
          fleetBookingStatus[item?.bookingStatus],
          formatDateAndTime(item?.bookFrom),
          formatDateAndTime(item?.bookTo),
          cities[item?.cityId],
          "₹ " + item?.costToCustomer,
          item?.customerName,
          item?.customerId,
          item?.customerEmail,
          item?.customerMobile,
          item?.lineItems,
        ),
      )) ||
    [];

  const getVechileBookingListings = async (page = 0, pageSize = 20) => {
    if (!vehicleId) return;

    let query = "";

    if (filteredKeys?.length) {
      query += `&bookingStatus=[${filteredKeys}]`;
    }

    const limit = pageSize;
    const offset = page * pageSize;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/vehicleservices/fetch-bookings-to-tag?vehicleId=${vehicleId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setBookingDetails(data?.dataValues || []);
        setTotalCount(data?.dataValues.length || 0);
      }
    } catch (error) {
      console.error("Error fetching bookings:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (workOrderDetail) {
      setVehicleId(workOrderDetail.vehicleId);
    }
    getCityNameAPI();
    if (typeof getTaggedBookings === "function") {
      getTaggedBookings(workOrderDetail?.id);
    }
  }, [workOrderDetail]);

  useEffect(() => {
    if (vehicleId) {
      getVechileBookingListings(paginationModel.page, paginationModel.pageSize);
    }
  }, [vehicleId, paginationModel]);

  useEffect(() => {
    if (workOrderDetail) {
      setVehicleId(workOrderDetail.vehicleId);
      setPaginationModel((prev) => ({ ...prev, page: 0 }));
    }
  }, [workOrderDetail]);

  const handleTagAPI = async (data) => {
    const damageCharges = chargesData?.filter(
      (item) => damageChargeInvertedId === String(item?.lineItemSubType),
    );

    const downtimeCharges = chargesData?.filter(
      (item) => downTimeChargeInvertedId === String(item?.lineItemSubType),
    );

    const damageAmount = damageCharges?.reduce(
      (sum, item) => sum + item.amount,
      0,
    );

    let attachmentsImg = [];

    const downtimeAmount = downtimeCharges?.reduce(
      (sum, item) => sum + item.amount,
      0,
    );
    const damageAttachments = damageCharges?.map((item) =>
      attachmentsImg.push(item.imageUrl),
    );

    const downtimeAttachments = downtimeCharges?.map((item) =>
      attachmentsImg.push(item.imageUrl),
    );

    let payload = {
      serviceId: workOrderDetail?.id,
      bookingId: data?.id,
      bookingCode: data?.bookingCode,
      customerId: data?.customerId,
      customerName: data?.customerName,
      customerEmail: data?.customerEmail,
      customerMobile: data?.customerMobile,
      damageChargesCollected: damageAmount,
      downtimeChargesCollected: downtimeAmount,
      attachments: JSON.stringify(attachmentsImg),
    };
    // return;
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicleservicetaggedbookings`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(payload),
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.success("Booking Tag Details Updated Successfully", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        setChargesData([]);
        await getTaggedBookings(workOrderDetail?.id);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  const handleSearch = () => {
    if (!searchvalues) {
      setFilteredBookings([]);
      return;
    }

    const result = bookingdetails.filter((item) =>
      item?.bookingCode?.toLowerCase().includes(searchvalues.toLowerCase()),
    );

    setFilteredBookings(result);
  };

  const handleClear = () => {
    setSearchValues("");
    setFilteredBookings([]);
  };

  const handleConfirmTag = async () => {
    if (confirmModal.row) {
      await handleTagAPI(confirmModal.row);
    }
    setConfirmModal({ open: false, row: null });
  };
  return (
    <>
      {confirmModal.open && chargesData[0]?.bookingId === confirmModal.row?.id && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-2xl shadow-lg p-6 w-[350px]">
            <h2 className="text-lg font-semibold mb-4">Confirm Tag Booking</h2>
            <p className="text-sm text-gray-600 mb-6">
              Are you sure you want to tag this booking?
            </p>

            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 rounded-lg border"
                onClick={() => setConfirmModal({ open: false, row: null })}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 rounded-lg bg-blue-600 text-white"
                onClick={handleConfirmTag}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div class="flex items-center justify-end p-2">
        <div class="rounded-lg bg-gray-200 p-2">
          <div class="flex">
            <input
              type="text"
              className="w-full max-w-[160px] bg-white pl-2 text-base font-semibold outline-0"
              value={searchvalues}
              onChange={(e) => {
                setSearchValues(e.target.value);
              }}
            />
            <button
              onClick={handleSearch}
              className="bg-blue-500 p-2 rounded-tr-lg rounded-br-lg text-white font-semibold hover:bg-blue-800 transition-colors"
            >
              Search
            </button>

            <button
              onClick={handleClear}
              className="ml-2 bg-gray-400 p-2 rounded text-white"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
      

      <div className="max-w-6xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {rows.map((row) => {
          const handleTag = async (row) => {
            if (!chargesData.length > 0) {
              toast.error(
                "Need to View the Charges and tag then booking to the work order",
              );
              return;
            } else if ( chargesData[0]?.bookingId !== row?.id) {  
              toast.error("Please click on view charges and then click on tag to tag the booking to the work order");
              return  
            } else {
              setConfirmModal({ open: true, row });              
            }
          };

          return (
            <div key={row.id} className="w-full h-[220px] [perspective:1000px]">
              <div
                className={`relative w-full h-full transition-transform duration-500 [transform-style:preserve-3d] ${
                  flippedCard === row.id ? "[transform:rotateY(180deg)]" : ""
                }`}
              >
                {/* FRONT */}
                <div className="absolute inset-0 [backface-visibility:hidden] bg-white border rounded-2xl shadow-md p-5">
                  <div className="flex justify-between items-center mb-3">
                    <h2 className="text-lg font-semibold text-gray-800">
                      {row.bookingCode}
                    </h2>
                    <span className="text-sm px-3 py-1 bg-gray-100 rounded-full">
                      {row.bookingstatus}
                    </span>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-gray-600">
                    <p>
                      <span className="font-medium">Start Date:</span>{" "}
                      {row.startdate}
                    </p>
                    <p>
                      <span className="font-medium">End Date:</span>{" "}
                      {row.enddate}
                    </p>
                    <p>
                      <span className="font-medium">City:</span> {row.city}
                    </p>
                    <p>
                      <span className="font-medium">Source:</span> {row.source}
                    </p>
                  </div>

                  <div className="flex justify-between items-center mt-4">
                    <button
                      onClick={() => handleViewCharges(row.id, row?.lineItems)}
                      className="text-blue-500 text-sm hover:underline"
                    >
                      View Charges
                    </button>

                    <button
                      onClick={() => {
                        const navigate = `/viewallbookings?bookingid=${row?.bookingCode}&display=true`;
                        window.open(navigate, "_blank");
                      }}
                      className="text-blue-500 text-sm hover:underline"
                    >
                      View Bookings
                    </button>

                    <button
                      onClick={() => handleTag(row)}
                      disabled={taggedBookings?.some(
                        (item) => item?.bookingId === row?.id,
                      )}
                      className="px-4 py-1.5 bg-blue-500 text-white rounded-md text-sm hover:bg-blue-600 disabled:bg-gray-400 disabled:cursor-not-allowed"
                    >
                      {taggedBookings?.some(
                        (item) => item?.bookingId === row?.id,
                      )
                        ? "Tagged"
                        : "Tag"}
                    </button>
                  </div>
                </div>

                {/* BACK */}
                <div className="absolute inset-0 [transform:rotateY(180deg)] [backface-visibility:hidden] bg-gray-50 border rounded-2xl shadow-md p-5">
                  <h2 className="text-md font-semibold mb-3">Charges</h2>

                  {chargesData.length > 0 ? (
                    <div className="mt-2">
                      <div className="max-h-28 overflow-y-auto border rounded-lg">
                        <table className="min-w-full text-xs">
                          <thead className="bg-gray-100 text-gray-600 sticky top-0">
                            <tr>
                              <th className="px-2 py-1 text-left">Type</th>
                              <th className="px-2 py-1 text-left">Image</th>
                              <th className="px-2 py-1 text-right">Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {chargesData.map((item, idx) => (
                              <tr key={idx} className="border-t">
                                <td className="px-2 py-1">
                                  {bookingCharges[item?.lineItemSubType] || "-"}
                                </td>

                                <td className="px-2 py-1">
                                  {item?.imageUrl ? (
                                    <img
                                      src={item.imageUrl}
                                      alt="charge"
                                      onClick={() =>
                                        handleImageOpen(item.imageUrl)
                                      }
                                      className="w-8 h-8 object-cover rounded"
                                    />
                                  ) : (
                                    "-"
                                  )}
                                </td>

                                <td className="px-2 py-1 text-right">
                                  ₹ {item?.amount || 0}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <p className="text-sm text-gray-500">No Data</p>
                  )}

                  <button
                    onClick={() => setFlippedCard(null)}
                    className="mt-4 text-blue-500 text-sm"
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="flex justify-center items-center mt-6 gap-4">
        <button
          disabled={paginationModel.page === 0}
          onClick={() =>
            setPaginationModel((prev) => ({
              ...prev,
              page: prev.page - 1,
            }))
          }
          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
        >
          Prev
        </button>

        <span className="text-sm">
          Page {paginationModel.page + 1} of{" "}
          {Math.ceil(totalCount / paginationModel.pageSize)}
        </span>

        <button
          disabled={
            (paginationModel.page + 1) * paginationModel.pageSize >= totalCount
          }
          onClick={() =>
            setPaginationModel((prev) => ({
              ...prev,
              page: prev.page + 1,
            }))
          }
          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </>
  );
};

export default Tagbookings;
